export const visitorCompanyTabKey = 'VISITOR_COMPANY_TAB';
export const eventLocationKey = 'EVENT_LOCATION';
export const linkVisitTypeToLocationKey = 'LINK_VISIT_TYPE_TO_LOCATION';
export const receptionTabKey = 'RECEPTION_TAB';
export const visitorsOnsiteKey = 'VIEW_VISITORS_ONSITE';
export const contactsMappingKey = 'CONTACTS_MAPPING';
export const contactsRequiredKey = 'CONTACTS_REQUIRED_FIELDS';
export const contactsUniqueKey = 'CONTACTS_UNIQUE_FIELDS';
export const visitorsMappingKey = 'VISITORS_MAPPING';
export const visitorsRequiredKey = 'VISITORS_REQUIRED_FIELDS';
export const visitorsUniqueKey = 'VISITORS_UNIQUE_FIELDS';
export const visitorCompaniesMappingKey = 'VISITORCOMPANIES_MAPPING';
export const visitorCompaniesRequiredKey = 'VISITOR_COMPANY_REQUIRED_FIELDS';
export const visitorCompaniesUniqueKey = 'VISITOR_COMPANY_UNIQUE_FIELDS';
export const visitorFormConfigKey = 'VISITOR_FORM_CONFIG';
export const eventVisitorFormConfigKey = 'EVENT_VISITOR_FORM_CONFIG';
export const visitorsListConfigKey = 'VISITORS_LIST_CONFIG';
export const visitorCompanyFormConfigKey = 'VISITOR_COMPANY_FORM_CONFIG';
export const visitorCompanyListConfigKey = 'VISITOR_COMPANY_LIST_CONFIG';
export const eventFormConfigKey = 'EVENT_FORM_CONFIG';
export const eventListConfigKey = 'EVENT_LIST_CONFIG';
export const eventHistoryConfigKey = 'EVENT_HISTORY_CONFIG';
export const contactFormConfigKey = 'CONTACT_FORM_CONFIG';
export const contactListConfigKey = 'CONTACT_LIST_CONFIG';
export const waitListTabKey = 'WAIT_LIST_TAB';
export const enableApprovalFlowKey = 'ENABLE_APPROVAL_FLOW';
export const waitListConfigKey = 'WAIT_LIST_CONFIG';
export const dashboardConfigKey = 'DASHBOARD_CONFIG';
export const autoRefreshTokenKey = 'AUTO_REFRESH_TOKEN_PERIOD';
export const matrixIntegrationEnabledKey = 'MATRIX_INTEGRATION_ENABLED';
export const matrixIntegrationConfigKey = 'MATRIX_INTEGRATION_CONFIG';
export const matrixSynchronizationConfigKey = 'MATRIX_SYNCHRONIZATION_CONFIG';

export const moduleOnLoadKeys = [
  eventListConfigKey,
  visitorsListConfigKey,
  contactListConfigKey,
  eventHistoryConfigKey,
  eventFormConfigKey,
  visitorFormConfigKey,
  eventVisitorFormConfigKey,
  contactFormConfigKey,
  visitorCompanyFormConfigKey,
  visitorCompanyListConfigKey,
  waitListConfigKey,
  enableApprovalFlowKey,
  dashboardConfigKey
];
